
"use strict"; // jshint ignore:line

import {
	//TextureLoader,
	MeshBasicMaterial,
	MeshPhongMaterial,
	Mesh,
	BoxGeometry
} from '../../../src/js/three.module.js';
import { ObjectClickHandler } from '../../utils/object-click-handler.js';
import { Painting } from '../classes/painting.js';
import { Statue } from '../classes/statue.js';
import { PaintingPlainFrame } from '../classes/painting-frame.js';
import { ObjectSolverByUuid } from './ObjectSolverService.js';

import { getTextureLoader } from '../../utils/loaders/loader-manager.js';

export default class OeuvresHandlerService {

	oeuvres_by_uuid = {};
	oeuvres_by_uid  = {};
	oeuvres = {};
	oeuvres_arr = [];

	async buildOeuvreHeading( client_oeuvre, fallback = '' ) {

		let heading;

		try {
			let catalogsService  = this.$injector.get( "catalogsService" );
			let gameSceneService = this.$injector.get( "gameSceneService" );

			let catalog = catalogsService.solveCurrentCatalog( catalogsService.solveCatalogs( gameSceneService.arrangement ));

			if (catalog) {

				let object = ObjectSolverByUuid( client_oeuvre.uid, 'oeuvre' );
				
				let catalog_item = catalog.solveItemByObject( object );

				if (catalog_item) {

					await catalogsService.getClientOeuvreItemAsync( catalog_item );

					heading = catalogsService.getItemHeading( catalog_item );
				}
			}
		} catch (e) {}


		if (!heading && client_oeuvre.with && client_oeuvre.with.oeuvre) {

			heading = client_oeuvre.with.oeuvre.title;

			if (!client_oeuvre.with.client_artist && client_oeuvre.artist_uid) {
				try {

					client_oeuvre.with.client_artist = await this.$userAssets.getClientArtistRaw( client_oeuvre.client_uid, client_oeuvre.artist_uid );

				} catch (e) {}
			}

			if (client_oeuvre.with.client_artist) {
				heading = client_oeuvre.with.client_artist.name + ": " + client_oeuvre.with.oeuvre.title;
			}
		}

		if (!heading) heading = oeuvre.title;

		if (!heading) heading = fallback;

		return heading;
	}

	static $inject = ["$userAssets","$http","$q","$injector","$sce","ipCookie","$ApiHandler","$User","userActionHistoryService","wallsHandlerService","Notification","gettextCatalog" ]; // jshint ignore:line

	constructor( $userAssets, $http, $q, $injector, $sce, ipCookie, $ApiHandler, $User, userActionHistoryService, wallsHandlerService, Notification, gettextCatalog ) {

		this.$userAssets      = $userAssets;
		this.$injector        = $injector;

		OeuvresHandlerService.getInstance = () => this;

		var self = this
		
		/********************/

		var texLoader = /* new TextureLoader() */ getTextureLoader();

		var emptyMaterial = new MeshBasicMaterial({ alphaTest: 0.1, opacity: 0 });

		var paintingTextureSize = 512;

		function buildOeuvre( o, opts ) {
			opts = opts || {};

			opts.img_uid = opts.img_uid || o.with.oeuvre.img_uid;

			/**
			 * @TODO: pitäisi sallia ilman img_uid'ta kohteiden lisääminen, sillä työkalun tulisi olla mahdollisimman riippumaton käyttötapauksista.
			 * fallbackaamalla opts.img_uid = 'null' teos toimii täysin tarkoituksenmukaisesti.
			 * Vaihtoehtona voidaan fallbackata client.default.placeholder_oeuvre_img_uid'aan tai johonkin vapaavalintaiseen materialUrl'aan
			 */

			//if (!opts.img_uid) throw "Unable to use an artwork without image";
			
			let materialUrl, img_uid;
			
			if (opts.img_uid) {

				img_uid = opts.img_uid;
			}

			if (!materialUrl) {

				if (!img_uid) {

					// if (!confirm( `Teoksesta ${ o.with.oeuvre.title } puuttuu teoskuva. Haluatko silti lisätä sen?` ))
					throw "Unable to use an artwork without image";

					img_uid = "null";
				}
					
				materialUrl = `/i/${ img_uid }?size=${ paintingTextureSize }x${ paintingTextureSize }!`;
			}

			var material = new MeshPhongMaterial({
				map: texLoader.load( materialUrl )
			});

	//		if( o.with.oeuvre.shape != null && o.with.oeuvre.shape != "RECTANGLE" ){
			if (true) {
				material.alphaTest = 0.1;
				material.opacity = 1.0
				material = [ emptyMaterial, emptyMaterial, emptyMaterial, emptyMaterial, material, emptyMaterial ];
			}

			var width_cm  = parseFloat( o.with.oeuvre.width );
			var height_cm = parseFloat( o.with.oeuvre.height );
			var depth_cm  = parseFloat( o.with.oeuvre.depth || 0 );

			var noeuvre = new Painting( o.uid, width_cm / 100, height_cm / 100, material, depth_cm / 100);


			noeuvre.$frames = noeuvre.$frames || {};
			var $frames = genFramingOpts( );
			if ($frames.canvas) noeuvre.$frames.canvas = $frames.canvas;
			if ($frames.frame)  noeuvre.$frames.frame  = $frames.frame;

			noeuvre.genFrames( noeuvre.$frames );



			noeuvre.img_url_thumb = "/i/"+ opts.img_uid +"?size=200x200^";

			noeuvre.uid       = o.uid;
			noeuvre.title     = o.with.oeuvre.title;

			noeuvre.width_cm  = width_cm;
			noeuvre.height_cm = height_cm;
			noeuvre.depth_cm  = depth_cm;

			noeuvre.description = $sce.trustAsHtml(o.with.oeuvre.description);
			noeuvre.method_description = $sce.trustAsHtml(o.with.oeuvre.method_description);
			noeuvre.shape     = o.with.oeuvre.shape;
			noeuvre.$raw      = o;
			noeuvre.$raw_opts = opts;

			// Oletetaan suorakulmion muotoiseksi jos Teoksen tiedoissa on asetettu niin
			noeuvre.$rectangle = !!(!noeuvre.shape || ([ "SQUARE", "RECTANGLE_HORIZONTAL", "RECTANGLE_VERTICAL" ]).indexOf( noeuvre.shape ) != -1);

			// Kehystettävissä, jos Teoksen tiedoissa on asetettu kehykset tai teos on suorakulmio
			noeuvre.$frameable = !!(noeuvre.$$framing || noeuvre.$rectangle);

			if (!noeuvre.$frameable) {
				// Kehystyskelvottomalle teokselle estetään reunojen piirtäminen

				noeuvre.disableEdges = true;
			}


			if (noeuvre.width_cm == 1 && noeuvre.height_cm == 1) noeuvre.$warnings.push( "The width and height of the painting is 1 cm. Is this right?" );
			if (noeuvre.width_cm == 0 && noeuvre.height_cm == 0) noeuvre.$warnings.push( "The width and height of the painting is 0 cm. Is this right?" );

			try {
				if( $User && $User.clients && $User.clients[ o.client_uid ]){
					noeuvre.$user_access = $User.clients[ o.client_uid ].$$userRole || 0;
				}
			} catch( e ){ console.error( e ); }

			return noeuvre;

			function genFramingOpts(){
				o.with.images = o.with.images || {};
				if( opts.img_uid && o.with.images[ opts.img_uid ]){
					var framing = o.with.images[ opts.img_uid ].framing;
					if( framing && framing.custom ){
						var _arrOrder = [ "left","top","bottom","right" ], set;
						var $$framing = noeuvre.$$framing = angular.copy(framing.custom);

						if(( set = $$framing.canvas ) && set.sides ){
							$$framing.canvas.order = $$framing.canvas.order || _arrOrder;
							$$framing.canvas.rr = {};
							for (let i in $$framing.canvas.order) $$framing.canvas.rr[ $$framing.canvas.order[ i ]] = set.sides[ i ] / 100;
						}
						if(( set = $$framing.frame ) && set.sides ){
							$$framing.frame.order = $$framing.frame.order || _arrOrder;
							$$framing.frame.rr = {};
							for (let i in $$framing.frame.order) $$framing.frame.rr[ $$framing.frame.order[ i ]] = set.sides[ i ] / 100;
						}
					}
				}

				var fops = {}, _frame = opts.frame, _canvas = opts.canvas;
				if( _frame || _canvas ){
					if( _frame  ){
						fops.frame = new PaintingPlainFrame({ d: _frame.d, rr: _frame.rr, material: new MeshPhongMaterial({ color: _frame.color })});
					}
					if( _canvas ){
						fops.canvas = new PaintingPlainFrame({ d: _canvas.d, rr: _canvas.rr, material: new MeshPhongMaterial({ color: _canvas.color })});
					}
				} else if( noeuvre.$$framing ){
					if( noeuvre.$$framing.frame ){
						fops.frame = new PaintingPlainFrame({ rr: noeuvre.$$framing.frame.rr, material: new MeshPhongMaterial({ color: noeuvre.$$framing.frame.color })});
					}
					if( noeuvre.$$framing.canvas ){
						fops.canvas = new PaintingPlainFrame({ rr: noeuvre.$$framing.canvas.rr, material: new MeshPhongMaterial({ color: noeuvre.$$framing.canvas.color })});
					}
				}
				return fops;
			}
		}


		function buildOeuvreByClientOeuvre( o, opts ) {
			return buildOeuvre( o, opts );
		}

		function buildOeuvreByRemoteOeuvre( o, opts ) {
			if( !o.data.image_data.url ){
				switch( o.remote_provider_key ){
					case "adlib":
						o.data.image_data.url = "/interfaces/adlib/records/"+ o.data.id +"/images/"+ o.data.image_data.id;
						break;
					default:
						debugger;
				}
			}

			var url = window.artestApiDomain+"/v2"+o.data.image_data.url+"?filters=asarray,onlydata,onlyattrs";

			return $q.when(o.$img_url || ($http({
				method : "GET",
				url    : url,
				headers: {
					"authorization" : ipCookie("authorization")
				}
			}).then(function(response){
				return response.data[0].data;
			}))).then(function( src ){
				var fops = {}, _frame, _canvas;
				opts = opts || {};

				if (_frame  = opts.frame)  fops.frame  = { d : _frame.d,  rr : _frame.rr,  material : new MeshPhongMaterial( { color: _frame.color  } ) };
				if (_canvas = opts.canvas) fops.canvas = { d : _canvas.d, rr : _canvas.rr, material : new MeshPhongMaterial( { color: _canvas.color } ) };

				var noeuvre = new Painting(o.uid,
					parseFloat(o.data.width) / 100,
					parseFloat(o.data.height) / 100,
					new MeshPhongMaterial({ map : texLoader.load( src )})
				).genFrames(fops);

				noeuvre.title     = o.data.name;
				noeuvre.width_cm  = parseFloat(o.data.width);
				noeuvre.height_cm = parseFloat(o.data.height);
				noeuvre.description = $sce.trustAsHtml(JSON.stringify(o.raw_data, null, "  "));
				noeuvre.method_description = $sce.trustAsHtml("");
				noeuvre.$raw      = o;
				noeuvre.$raw_opts = opts;
				noeuvre.img_url_thumb = noeuvre.img_url_thumb || src;
				return noeuvre;
			});
		}
		function buildStatue( o, opts ){
			var prms = true, obj;

			if( opts.obj_attachment_uid ){
				var attachment = o.with.oeuvre.attachments[ opts.obj_attachment_uid ];

				var defer, resource = "/attachments/" + opts.obj_attachment_uid + "?filters=onlydata,onlyattrs";

				try {
					defer = $ApiHandler.findOrGet( resource );
				} catch (error) { console.error( error ); }

				prms = $q.when( defer || $ApiHandler.get( resource )).then(function(result){
					o.with.object_attachment = result = result.data[opts.obj_attachment_uid];
					opts.obj = {
						attachment_uid: result.uid,
						path: "/ajax/attachments/"+ result.uid +"/"+ result.filename,
						scale: attachment.opts.scale
					};
				});
			} else {
				var material = new MeshPhongMaterial({
					map: texLoader.load( "/i/" + o.with.oeuvre.img_uid + "?size=" + paintingTextureSize + "x" + paintingTextureSize + "!")
				});

				material.alphaTest = 0.1;
				material.opacity = 1.0

				opts.obj = {
					mesh: new Mesh( new BoxGeometry(
						0.01 * parseFloat( o.with.oeuvre.width ),
						0.01 * parseFloat( o.with.oeuvre.height ),
						0.01 * parseFloat( o.with.oeuvre.depth || 0.01 )
					), [ emptyMaterial, emptyMaterial, emptyMaterial, emptyMaterial, material, emptyMaterial ])
				};
			}

			return $q.when(prms)
			.then(function(){
				return $q(function(resolve, reject){
					obj = new Statue( o.uid,
						parseFloat( o.with.oeuvre.width  ) / 100,
						parseFloat( o.with.oeuvre.height ) / 100,
						parseFloat( o.with.oeuvre.depth  ) / 100,
						opts,
						function(err, _obj){
							if( err ) reject( err );
							else resolve();
						}
					);
				});
			})
			.then(function(){
				obj.img_url_thumb = "/i/"+ (o.with.oeuvre.img_uid || self.defaults.statue_img_uid) +"?size=200x200^";

				obj.uid       = o.uid;
				obj.title     = o.with.oeuvre.title;
				obj.width_cm  = parseFloat(o.with.oeuvre.width);
				obj.height_cm = parseFloat(o.with.oeuvre.height);
				obj.depth_cm  = parseFloat(o.with.oeuvre.depth);
				obj.description = $sce.trustAsHtml(o.with.oeuvre.description);
				obj.method_description = $sce.trustAsHtml(o.with.oeuvre.method_description);
				obj.shape     = "3D";
				obj.$raw      = o;
				obj.$raw_opts = opts;
				obj.$lookAtPlayer = !opts.obj_attachment_uid;

				return obj;
			});
		}

		this.solveOeuvre = function( key ) {
			key = key.uid || (key.userData && key.userData.oeuvre_uid) || key;
			return this.oeuvres[ key ] || this.oeuvre_by_uuid[ key ];
		};

		this.push = function( obj ){
			if( obj.uid ) {
				if( !self.oeuvres[ obj.uid ]){
					self.oeuvres[ obj.uid ] = obj;
					self.oeuvres_arr.push( obj );
					self.oeuvres_by_uid[ obj.uid ] = self.oeuvres_by_uid[ obj.uid ] || {};
					self.oeuvres_by_uid[ obj.uid ][ obj.uuid ] = obj;
					self.oeuvres_by_uuid[ obj.uuid ] = obj;
				} else console.warn("$oeuvreHandler already have obj with same uid");
			} else if( typeof obj.then == "function" ){
				self.oeuvres_arr.push( obj );
			} else {
				 debugger;
			}
			return self.oeuvres[ obj.uid ];
		}

		this.addPainting = function( o, opts ) {
			opts = opts || {};
			if (o.uid.substr(0,2) == "92"){
				if( o.with && o.with.oeuvre && o.with.oeuvre.shape == "3D" ){
					return this.addStatue( o, opts );
				} else {
					return self.push(buildOeuvreByClientOeuvre( o, opts ));
				}
			} else if (o.uid.substr(0,2) == "BC")
				return self.push(buildOeuvreByRemoteOeuvre( o, opts ));
			else return self.push(buildOeuvre( o, opts ));
		};

		this.addStatue = function( o, opts ){
			for( var uid in o.with.oeuvre.attachments ){
				if( o.with.oeuvre.attachments[ uid ].type == "3D" ){
					opts.obj_attachment_uid = uid;
					break;
				}
			}
			self.push( buildStatue( o, opts ));
		}

		this.addPaintings = function( oeuvres ) {
			var errors = [];

			for (var i in oeuvres) {
				try {
					self.addPainting( oeuvres[i], oeuvres[i].opts );
				} catch (error) {
					console.error( error );
					errors.push( error );
				}
			}

			return $q.all( self.oeuvres_arr ).then(function( oeuvres ){

				for (var i in oeuvres) try {
					var oeuvre = oeuvres[ i ];

					self.oeuvres[ oeuvre.uid ] = self.oeuvres_arr[ i ] = oeuvres[ i ];
					self.oeuvres_by_uid[ oeuvre.uid ] = self.oeuvres_by_uid[ oeuvre.uid ] || {};
					self.oeuvres_by_uid[ oeuvre.uid ][ oeuvre.uuid ] = oeuvre;
					self.oeuvres_by_uuid[ oeuvre.uuid ] = oeuvre;

					if (!oeuvre.$clickHandler) {
						new ObjectClickHandler([{ conditions: "notInEditor", fn: "openOeuvreInfoModal", arguments: [ oeuvre.uid ] }], oeuvre );
					}
				} catch (error) {
					console.error( error );
					errors.push( error );
				}

				if (errors.length > 0) {

					console.error( errors );

					var notification = {
						title: gettextCatalog.getString( "Failed to add oeuvres!" ),
						message: gettextCatalog.getString( 'Failed to add {{ $count }} oeuvres into arrangement', { '$count': errors.length })
					};

					var str_errors = errors.filter( error => typeof error == "string" ).filter(( v, i, a ) => a.indexOf( v ) == i );

					if (str_errors.length > 0) {
						for (var s of str_errors) {
							notification.message += "<br>- " + s;
						}
					}

					Notification.error( notification );
				}

				return self.oeuvres;
			});
		}

		this.rmOeuvre = function( oeuvre ){
			var uid = typeof oeuvre == "string" ? oeuvre : oeuvre.uid;
			oeuvre = this.oeuvres[ uid ];

			if( !oeuvre ) throw new Error( "OeuvresHandlerService.rmOeuvre :: Oeuvre not found" );

			var idx = this.oeuvres_arr.indexOf( oeuvre );
			if( idx != -1 ) this.oeuvres_arr.splice( idx, 1 );

			oeuvre.mesh.geometry.dispose();
			oeuvre.mesh.material.dispose && oeuvre.mesh.material.dispose();

			delete this.oeuvres_by_uuid[ oeuvre.uuid ];
			if (this.oeuvres_by_uid[ oeuvre.uid ]) delete this.oeuvres_by_uid[ oeuvre.uid ][ oeuvre.uuid ];
			delete this.oeuvres[ uid ];
		}

		this.init = function( oeuvres ) {
			this.defaults = this.defaults || {};
			this.defaults.statue_img_uid = this.defaults.statue_img_uid || "";
			return this.addPaintings( oeuvres );
		}

		/*
		██    ██ ███████ ███████ ██████   █████   ██████ ████████ ███████ ██   ██ ██ ███████ ████████  ██████  ██████  ██    ██
		██    ██ ██      ██      ██   ██ ██   ██ ██         ██    ██      ██   ██ ██ ██         ██    ██    ██ ██   ██  ██  ██
		██    ██ ███████ █████   ██████  ███████ ██         ██    ███████ ███████ ██ ███████    ██    ██    ██ ██████    ████
		██    ██      ██ ██      ██   ██ ██   ██ ██         ██         ██ ██   ██ ██      ██    ██    ██    ██ ██   ██    ██
		 ██████  ███████ ███████ ██   ██ ██   ██  ██████    ██    ███████ ██   ██ ██ ███████    ██     ██████  ██   ██    ██
		*/

		userActionHistoryService.addActs({
			"oeuvre.move": {
				"undo": function(act){
					act.oeuvre.setPlace( act.prev_position, act.prev_rotation );
				},
				"redo": function(act){
					act.oeuvre.setPlace( act.new_position, act.new_rotation, act.intersect || undefined );
				}
			},
			"oeuvre.place": {
				"undo": function(act){
					act.oeuvre.isSetted = act.oeuvre.mesh.visible = false;
					helpers.refreshOeuvreHelper( act.oeuvre );
					wallsHandlerService.refresh( act.oeuvre );
				},
				"redo": function(act){
					act.oeuvre.isSetted = act.oeuvre.mesh.visible = true;
					act.oeuvre.setPlace( act.new_position, act.new_rotation );
				}
			},
			"oeuvre.visibility.hide": {
				"redo": function(act){ act.oeuvre.mesh.visible = false; },
				"undo": function(act){ act.oeuvre.mesh.visible = act.prev_visible; },
				"$postCallback": function(act){ helpers.refreshOeuvreHelper( act.oeuvre ); wallsHandlerService.refresh( act.oeuvre ); }
			},
			"oeuvre.visibility.show": {
				"redo": function(act){ act.oeuvre.mesh.visible = true; },
				"undo": function(act){ act.oeuvre.mesh.visible = act.prev_visible; },
				"$postCallback": function(act){ helpers.refreshOeuvreHelper( act.oeuvre ); wallsHandlerService.refresh( act.oeuvre ); }
			},
			"oeuvre.visibility.toggle": {
				"redo": function(act){ act.oeuvre.mesh.visible = !act.prev_visible; },
				"undo": function(act){ act.oeuvre.mesh.visible = act.prev_visible; },
				"$postCallback": function(act){ helpers.refreshOeuvreHelper( act.oeuvre ); wallsHandlerService.refresh( act.oeuvre ); }
			},
			"oeuvre.setZOffset": {
				"do": function( oeuvre, z_offset ){
					userActionHistoryService.addUndo("oeuvre.setZOffset", {
						oeuvre        : oeuvre,
						prev_z_offset : oeuvre.z_offset,
						new_z_offset  : oeuvre.z_offset = z_offset
					});
					oeuvre.setPlaceByIntersect();
				},
				"undo": function(act){ act.oeuvre.z_offset = act.prev_z_offset; },
				"redo": function(act){ act.oeuvre.z_offset = act.new_z_offset;  },
				"$postCallback": function(act){ act.oeuvre.setPlaceByIntersect(); }
			},
			"oeuvre.framing.set": {
				"$prevCallback": function(act){ act.oeuvre.$frames = act.oeuvre.$frames || {}; },
				"undo": function( act ){
					this.injector( act, "frame",  act.old_frame );
					this.injector( act, "canvas", act.old_canvas );
				},
				"redo": function( act ){
					this.injector( act, "frame",  act.new_frame );
					this.injector( act, "canvas", act.new_canvas );
				},
				"$postCallback": function(act){ act.oeuvre.$genFrames(); },
				"injector": function( act, t, vals ){
					if( vals && act.oeuvre.$frames[t] ){
						vals.rr    == null || (act.oeuvre.$frames[t].rr    = vals.rr);
						vals.d     == null || (act.oeuvre.$frames[t].d     = vals.d);
						vals.color == null || (act.oeuvre.$frames[t].material.color.set( vals.color ));
					}
				}
			},
			"oeuvre.setDisableEdges": {
				"do": function( oeuvre, disable ) {

					var act = {
						uid:       oeuvre.uid,
						new_value: !!disable,
						old_value: !!oeuvre.disableEdges
					};

					userActionHistoryService.addUndo( "oeuvre.setDisableEdges", act );

					userActionHistoryService.acts[ "oeuvre.setDisableEdges" ].redo( act );

					userActionHistoryService.acts[ "oeuvre.setDisableEdges" ].$postCallback( act );

				},
				"redo": function( act, oeuvre ){
					if (oeuvre = self.oeuvres[ act.uid ]) oeuvre.disableEdges = act.new_value;
				},
				"undo": function( act, oeuvre ){
					if (oeuvre = self.oeuvres[ act.uid ]) oeuvre.disableEdges = act.old_value;
				},
				"$postCallback": function( act, oeuvre ) {
					if (oeuvre = self.oeuvres[ act.uid ]) {
						oeuvre.frameObj.visible = oeuvre.canvasObj.visible = !oeuvre.disableEdges;
					}
				}
			}
		});
	}

	solvePaintingOeuvreFramings( client_oeuvre = {} ) {

		let result = { canvas: null, frame: null, image: null };

		for (let label in result) {
			result[ label ] = this.solvePaintingOeuvreFraming( client_oeuvre, label ) || null;
		}

		return result;
	}
		
	solvePaintingOeuvreFraming( client_oeuvre = {}, label = 'frame' ) {
	
		let { oeuvre, images } = (client_oeuvre.with || {});

		if (oeuvre && oeuvre.img_uid) {

			let image = images && images[ oeuvre.img_uid ];

			if (image) try {
			
				var edges = image.framing && image.framing.edges && image.framing.edges[ label ];

				if (edges && edges.sides) {

					var o = edges.sides;

					var crop_str = encodeURIComponent(
								parseInt( 100 * (o.right - o.left ))
						+ "x" + parseInt( 100 * (o.bottom - o.top )) 
						+ "+" + parseInt( 100 * o.left )
						+ "+" + parseInt( 100 * o.top )
					);

					return {
						crop_str,
						sides: edges.sides,
						query_param: "crop=%25" + crop_str
					};
				}
			} catch (e) {
				console.error( e );
			}
		}
	}
}
